// extracted by mini-css-extract-plugin
export default {"fieldset":"EPJSoo","badge":"bHm_gU","two-column":"arO8ZL","twoColumn":"arO8ZL","horizontal":"NR_GtH"};